export function ensurePortalRoot(id: string): HTMLElement | undefined {
  if (typeof document === 'undefined') return undefined;

  let node = document.getElementById(id);
  if (!node) {
    node = document.createElement('div');
    node.id = id;
    document.body.appendChild(node);
  }
  return node;
}
